module.exports = __webpack_public_path__ + "img/shuziren.a8c429b7.png";